module.exports = __webpack_public_path__ + "img/Character_Razor_Thumb.123f3f9b.png";